import { Terms } from "../../types/terms";

const terms: Partial<Terms> = {
  units: {
    metres: "meters",
    metresPerSecond: "meters per second",
  },
};

export default terms;
